import { createContext } from "react"

export const MovieAPIContext = createContext()
